var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignTopArrow03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0011 2.99879L6.00252 2.99879M6.00252 2.99879L13.7625 2.99879M6.00252 2.99879L6.00252 19.383C6.00252 19.9493 6.00252 20.2325 6.11151 20.4489C6.20738 20.6391 6.36036 20.7939 6.54853 20.8908C6.76244 21.001 7.04246 21.001 7.60252 21.001H8.64516C9.20521 21.001 9.48524 21.001 9.69915 20.8908C9.88731 20.7939 10.0403 20.6391 10.1362 20.4489C10.2452 20.2325 10.2452 19.9493 10.2452 19.383V2.9988M13.7625 2.99879L18.0052 2.99879M13.7625 2.99879L13.7625 15.5378C13.7625 16.1042 13.7625 16.3874 13.8715 16.6037C13.9674 16.794 14.1204 16.9487 14.3085 17.0457C14.5224 17.1559 14.8025 17.1559 15.3625 17.1559L16.4052 17.1559C16.9652 17.1559 17.2452 17.1559 17.4591 17.0457C17.6473 16.9487 17.8003 16.794 17.8962 16.6037C18.0052 16.3874 18.0052 16.1042 18.0052 15.5378V2.99879M18.0052 2.99879L21.0011 2.99879",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignTopArrow03);
export default __webpack_public_path__ + "static/media/align-top-arrow-03.dff6893e39843611f834afc50d714a49.svg";
export { ForwardRef as ReactComponent };